import "react-image-gallery/styles/css/image-gallery.css";
import "../../App.css"
import {game_unavailable_text} from "../../common/constants";

import {useNavigate} from "react-router-dom";
import {Row, Col}  from 'react-bootstrap';
import ImageGallery from 'react-image-gallery';

import {getSceneInfo} from "../../common/BackendConnections";
import {createSession} from '../../common/BackendConnections'
import NavigationHeader from "../Layout/NavigationHeader";
import LoadingComponent from '../LoadingComponent'
import {useEffect, useState} from "react";
import {useContext} from "react";
import PatientContext from "../../store/patient-context";
import  {createMarkup}  from '../../common/utils/dom_utils'

// -----------------------------------
function GameInfoComponent(props) {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [sceneInfo, setSceneInfo] = useState(
    {name: undefined, cover_image: undefined, status: undefined});
  const patientCtx = useContext(PatientContext);
  const gameId = props.gameId

  useEffect(() => {
    setIsLoading(true);
    getSceneInfo(gameId).then((response) => {
      setSceneInfo(response.data);
      setIsLoading(false);
    }).catch((error) => {
      console.error(`Error while getting scene info. Details: ${error}`);
      setIsLoading(false);
    });
  }, [gameId]);

  const handleBackButtonClick = (event) => {
    event.preventDefault();
    navigate("/games/");
  };
  const handleStartGameButtonClick = (event) => {
    event.preventDefault();

    createSession(patientCtx.patientId, gameId)
      .then(response => {
        const sessionId = response.data.created_id;
        navigate(`/game_startup/${gameId}/${sessionId}`);
      })
      .catch(error => {
        console.debug(`Failed to create a session. Details: ${error}`)
      })
  };

  let gamePath = "";
  let game_images = [];

  if (sceneInfo.name) {
    gamePath = "Games";
    if (sceneInfo.category)
      gamePath += " > " + sceneInfo.category;
    gamePath += " > " + sceneInfo.name;
    // ---------------

    if (sceneInfo.images) {
      for (let img of sceneInfo.images) {
        game_images.push({
          original: img,
          thumbnail: img
        });
      }
    }
  }

  // ----------------------------------------------------------------------------
  return (
    <div className={"page_content"}>
      <NavigationHeader />

      {sceneInfo.name ?
        <div>
          <span className={"fainted_text mt-3"}>{gamePath}</span>
          <h1 className={"mt-0"}>{sceneInfo.name}</h1>
          <Row style={{marginTop:"1em", marginBottom:"5em"}}>
            <Col sm={12} lg={6}>
              <div style={{paddingBottom: "1em", maxWidth: '800px'}}>
                {(game_images.length === 0)?

                  <img className={"NavBar-logo"}
                       style={{width: "100%", height: "auto"}}
                       src={sceneInfo.cover_image ? sceneInfo.cover_image: "/images/icons8-image-100.png"}
                       alt="Game cover" height={430}/>
                  :
                  <ImageGallery items={game_images}
                                showFullscreenButton={false}/>
                }
              </div>
            </Col>

            <Col sm={12} lg={5} xs={{offset: 1}}>
              <div>
                <h3>About</h3>
                <div className={"mt-3"}
                     style={{textAlign: "justify"}}
                     dangerouslySetInnerHTML={createMarkup(sceneInfo.description)}/>
              </div>
              <div className={"mt-4 small_text"}>{sceneInfo.notes}</div>
              <div className={"mt-4"} dangerouslySetInnerHTML={createMarkup(sceneInfo.specs)}/>
              {(sceneInfo.status !== 'active') &&
                <span style={{color: "red"}}><br/>{game_unavailable_text}</span>}
            </Col>
          </Row>

          <Row style={{marginTop:"1em", marginBottom:"5em"}}>
            <Col xs={6}>
              <button className={"app-button-style2"}
                      onClick={handleBackButtonClick}>Back to Games</button>
            </Col>
            <Col xs={4}>
              <button className={"colored_text_button"}
                      style={{maxWidth: "24ch"}}
                      disabled={sceneInfo.status !== 'active'}
                      onClick={handleStartGameButtonClick}>Start</button>
            </Col>
          </Row>
        </div>
        :
        isLoading ?
          <LoadingComponent/>
          :
          <div>
            <h1 className={"mt-3"}>Invalid game identifier</h1>
            <button className={"app-button-style2 active"}
                    onClick={handleBackButtonClick}>Back to Games</button>
          </div>
      }
    </div>
  );
}

export default GameInfoComponent;
